import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { useAuth, formatApiError } from "@/context/AuthContext";
import { toast } from "sonner";

export const AuthDialog = ({ open, onOpenChange, onSuccess }) => {
  const { login, register } = useAuth();
  const [tab, setTab] = useState("login");
  const [loading, setLoading] = useState(false);
  const [role, setRole] = useState("customer");
  const [form, setForm] = useState({ name: "", email: "", password: "", phone: "" });

  const upd = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (tab === "login") {
        const u = await login(form.email, form.password);
        toast.success(`Willkommen zurück, ${u.name}!`);
      } else {
        const u = await register({ ...form, role });
        toast.success(`Konto erstellt. Willkommen, ${u.name}!`);
      }
      onOpenChange(false);
      onSuccess && onSuccess();
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Fehler");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" data-testid="auth-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading text-2xl">Willkommen bei eventimo</DialogTitle>
        </DialogHeader>
        <Tabs value={tab} onValueChange={setTab} className="w-full">
          <TabsList className="grid grid-cols-2 w-full">
            <TabsTrigger value="login" data-testid="tab-login">Anmelden</TabsTrigger>
            <TabsTrigger value="register" data-testid="tab-register">Registrieren</TabsTrigger>
          </TabsList>
          <form onSubmit={submit} className="space-y-4 mt-4">
            <TabsContent value="register" className="space-y-4 mt-0">
              <div>
                <Label>Name</Label>
                <Input data-testid="auth-name" value={form.name} onChange={upd("name")} placeholder="Dein Name" required={tab === "register"} />
              </div>
              <div className="grid grid-cols-2 gap-2">
                <Button type="button" variant={role === "customer" ? "default" : "outline"}
                  className={role === "customer" ? "bg-emerald-600 hover:bg-emerald-700" : ""}
                  onClick={() => setRole("customer")} data-testid="role-customer">Als Kunde</Button>
                <Button type="button" variant={role === "partner" ? "default" : "outline"}
                  className={role === "partner" ? "bg-emerald-600 hover:bg-emerald-700" : ""}
                  onClick={() => setRole("partner")} data-testid="role-partner">Als Partner</Button>
              </div>
            </TabsContent>
            <div>
              <Label>E-Mail</Label>
              <Input data-testid="auth-email" type="email" value={form.email} onChange={upd("email")} placeholder="name@email.de" required />
            </div>
            <div>
              <Label>Passwort</Label>
              <Input data-testid="auth-password" type="password" value={form.password} onChange={upd("password")} placeholder="••••••••" required />
            </div>
            <Button type="submit" disabled={loading} className="w-full bg-emerald-600 hover:bg-emerald-700" data-testid="auth-submit">
              {loading ? "Bitte warten…" : tab === "login" ? "Anmelden" : "Konto erstellen"}
            </Button>
          </form>
        </Tabs>
      </DialogContent>
    </Dialog>
  );
};
